import EntityCrudPage from '../../shared/EntityCrudPage';
import { approvalConfig } from '../../config/entityConfigs';

const ApprovalsPage = () => <EntityCrudPage config={approvalConfig} />;

export default ApprovalsPage;
